import type { DetectionsLocales } from '@/types/lang/locales'
import { detectionsEn as libDetectionEn } from '@rfc/rfc-components-library/locales'
import { EDetectionActions } from '@rfc/rfc-components-library/store'

export const detectionsEn: DetectionsLocales = {
    ...libDetectionEn,
    api: {
        error: {
            ...libDetectionEn.api.error,
            [EDetectionActions.EXPORT_DETECTIONS]: 'Error while generating the file',
            [EDetectionActions.FETCH_DETECTIONS]: 'Error while fetching reads'
        },
        success: {
            ...libDetectionEn.api.error,
            [EDetectionActions.EXPORT_DETECTIONS]: 'File has been successfully generated',
            [EDetectionActions.FETCH_DETECTIONS]: 'Erreur pendant la récupération des détections'
        }
    },
    actions: {
        resetFilters: {
            button: 'Reset filters',
            title: 'Reset current filters',
            text: 'Do you really want to reset the current filters ?'
        }
    },
    export: {
        allDetections: 'All reads',
        currentPage: 'Only the current page (Page {page})',
        device: 'Device'
    },
    filters: {
        ...libDetectionEn.filters,
        bib: 'Bib',
        checkpoint: 'Checkpoint',
        event: 'Event',
        eventId: 'Event ID',
        timerId: 'Timer ID'
    },
    model: {
        ...libDetectionEn.model,
        bib: 'Bib',
        eventName: 'Event name',
        checkpointName: 'Checkpoint name',
        eventFilter: 'Event filter',
        timerFilter: 'Timer filter',
        withdrawal: 'Withdrawal'
    },
    table: {
        ...libDetectionEn.table,
        bib: 'Bib',
        checkpointName: 'Checkpoint',
        eventName: 'Event',
        deviceId: 'Device ID',
        eventFilter: 'Event ID',
        timerFilter: 'Timer ID'
    }
}
